import { defineComponent as _defineComponent } from 'vue'
import { QrcodeStream } from 'vue-qrcode-reader'
import { useDevicesList, useVModel } from '@vueuse/core'
import { Ref, computed, getCurrentInstance, ref } from 'vue'
import DragAndDrop from './DragAndDrop.vue'
import QrScannerInput from './QrScannerInput.vue'
type QrResult = {
  rawValue: string;
}

import axios from 'axios'


export default /*#__PURE__*/_defineComponent({
  __name: 'ScannerQr',
  props: ['value'],
  emits: ['input', 'close'],
  setup(__props, { emit }) {

const props = __props

const { videoInputs: cameras } = useDevicesList()
const hasCamera = computed(() => cameras.value.length > 0)

const root = getCurrentInstance()?.proxy.$root




const value = useVModel(props, 'value', emit)

const scanningQr = ref(false)

const tipoEscaner = ref(0)

const qrFile = ref<File[]>([])

async function qrDetected(qrResult: Promise<{ content: string }> | null, qrFile?: Ref<File[]> | null) {

  scanningQr.value = true

  const formData = new FormData()
  if (qrResult != null) {
    const { content } = await qrResult
    formData.append('url', content)
  }
  if (qrFile?.value != null)
    formData.append('qr_file', qrFile.value[0])

  try {
    const { data } = await axios({
      url: "/api/comparativas/comparativa_desde_qr",
      method: "POST",
      data: formData,
    });
    console.log(data);

  } catch (error) {
    root.$emit("snack", `Ha ocurrido un error al crear la comparativa: ${error?.data?.detail}`, { type: 'error' });
  } finally {
    scanningQr.value = false
    value.value = false
    return
  }

}


return { __sfc: true,cameras, hasCamera, root, props, emit, value, scanningQr, tipoEscaner, qrFile, qrDetected, QrcodeStream, QrScannerInput }
}

})